import { Box, IconButton, styled } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';

export const Container = styled(Box)({
  height: '100%',
  gap: 8,
  display: 'flex',
  flexDirection: 'column'
});

export const InputContent = styled(Box)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  flex: 1
});

export const InputPlaceholder = styled(Box)({
  position: 'relative',
  padding: 10,
  borderRadius: 8,
  background: '#FAFAFB',
  color: '#92929D',
  fontSize: 16,
  display: 'flex',
  flexDirection: 'column',
  gap: 10
});

export const PlaceholderImage = styled(Box)({
  width: 68,
  height: 68,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid #AFBAC6',
  background: '#f8f9fa',
  borderRadius: 12
});

export const Image = styled('img')({
  width: 64,
  height: 64,
  border: '1px solid #AFBAC6',
  padding: 2,
  borderRadius: 12,
  objectFit: 'contain'
});

export const RemoveImage = styled(IconButton)({
  position: 'absolute',
  top: -8,
  right: -8,
  padding: 4,
  borderRadius: '50%',
  background: 'black',
  '& svg': {
    width: 20,
    minWidth: 20,
    height: 20,
    maxHeight: 20
  },
  '&:hover': {
    background: 'black'
  }
});

export const Actions = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: 12
});

export const SubmitButton = styled(SButton)({
  background: 'linear-gradient(135deg,  #256EE4 5%, #003A6C 30%, #001222 90%)',
  fontWeight: 500,

  '&.Mui-disabled': {
    opacity: 0.6,
    color: 'white'
  }
});

export const DropzoneContainer = styled(Box)({
  width: '100%',
  minHeight: 85,
  maxHeight: 85,
  borderWidth: 1,
  borderStyle: 'dashed',
  borderRadius: 12,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  position: 'relative',
  padding: '4px 0px',
  '&:hover': {
    borderColor: '#256EE4',
    backgroundColor: 'rgba(37, 110, 228, 0.05)'
  }
});

export const ErrorContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 16,
  padding: '8px 16px',
  backgroundColor: 'rgba(244, 67, 54, 0.08)',
  borderRadius: 8
});

export const ButtonsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: 16
});
